<template>
  <div v-if="hasTags">
    <div class="subTitle" v-text="title"></div>
    <div class="summary gap">
      <a class="class-tag badge badge-success" v-for="tag in hotKeywords"
         :href="actionUrl+'?keyword='+tag"
         target="_blank"
         v-text="tag"
         ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClinicTag',
  props: {
    title: String,
    actionUrl: String,
    hotKeywords: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
  },
  computed: {
    hasTags() {
      return this.hotKeywords && this.hotKeywords.length > 0;
    }
  }
};
</script>

<style scoped lang="scss">
.gap{
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    .class-tag {
      padding: 0.5rem 1rem;
      font-size: 1.1rem;
      border-radius: 5px;
      text-decoration: none;
      transition: background-color 0.2s ease-in-out;
      position: relative;

    /* Optional: Add some hover effect */
    &.badge-success{
      &:hover, &:focus {
         background: #5db635;
         transition: 0.3s;
       }
    }
  }
}
</style>
